import { rootRoute } from './root'
import { generalRoute } from './general'
import { communicationRoute } from './communication'
import { authenticationRoute } from './authentication'
import { accountAppRoute } from './accountApp'
import { scopesRoute } from './scopes'
import { securityRoute } from './security'
import { appearanceRoute } from './appearance'

export const settingsRoute = rootRoute.addChildren([
    generalRoute,
    authenticationRoute,
    accountAppRoute,
    scopesRoute,
    securityRoute,
    communicationRoute,
    appearanceRoute,
])
